import { motion } from "framer-motion";

const BackedBySection = () => {
  const mediaLogos = [
    { name: "Forbes", letters: "FORBES" },
    { name: "Bloomberg", letters: "Bloomberg" },
    { name: "CoinDesk", letters: "COINDESK" },
    { name: "TechCrunch", letters: "TechCrunch" },
    { name: "Decrypt", letters: "DECRYPT" },
  ];

  return (
    <section className="relative py-12 md:py-16 overflow-hidden" data-testid="backed-by-section">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#00D4FF]/5 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        {/* As Seen In */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 md:mb-12"
        >
          <span className="text-xs md:text-sm font-mono text-[#A1A1AA] tracking-widest uppercase">
            As Featured In
          </span>
        </motion.div>

        {/* Media logos - Scrollable on mobile */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center items-center gap-6 md:gap-8 lg:gap-16 mb-10 md:mb-16"
        >
          {mediaLogos.map((logo, index) => (
            <motion.div
              key={logo.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <span 
                className="font-['Unbounded'] text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-[#A1A1AA]/40 group-hover:text-[#A1A1AA]/80 transition-all duration-300"
                style={{ letterSpacing: logo.name === "Forbes" ? "0.2em" : "0.05em" }}
              >
                {logo.letters}
              </span>
            </motion.div>
          ))}
        </motion.div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#00D4FF]/30 to-transparent mb-10 md:mb-16" />

        {/* Backed By */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 md:mb-12"
        >
          <span className="text-xs md:text-sm font-mono text-[#A1A1AA] tracking-widest uppercase">
            Backed By Industry Leaders
          </span>
        </motion.div>

        {/* Partner/Investor cards - Responsive grid */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-wrap justify-center items-center gap-3 md:gap-6"
        >
          {[
            { name: "Web3 Foundation", icon: "W3" },
            { name: "Solana Ventures", icon: "SV" },
            { name: "Coinbase Ventures", icon: "CB" },
            { name: "Binance Labs", icon: "BL" },
            { name: "Sequoia", icon: "SQ" },
          ].map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-2 md:gap-3 px-4 md:px-6 py-3 md:py-4 rounded-xl md:rounded-2xl glass ice-hover cursor-pointer group"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-gradient-to-br from-[#00D4FF]/20 to-[#8B5CF6]/20 border border-white/10 flex items-center justify-center group-hover:border-[#00D4FF]/50 transition-colors flex-shrink-0">
                <span className="font-['Unbounded'] text-xs md:text-sm font-bold text-[#00D4FF]">
                  {partner.icon}
                </span>
              </div>
              <span className="text-xs md:text-sm font-medium text-[#A1A1AA] group-hover:text-white transition-colors">
                {partner.name}
              </span>
            </motion.div>
          ))}
        </motion.div>

        {/* Disclaimer */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center text-[10px] md:text-xs text-[#A1A1AA]/50 mt-6 md:mt-8 px-4"
        >
          * Partnership discussions in progress. Logos shown for illustration purposes.
        </motion.p>
      </div>
    </section>
  );
};

export default BackedBySection;
